import React from "react"
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles"
import Dialog from "@material-ui/core/Dialog"
import MuiDialogTitle from "@material-ui/core/DialogTitle"
import DialogContent from "@material-ui/core/DialogContent"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import Typography from "@material-ui/core/Typography"

function Simple(props) {
	const { title, open, content, onClose } = props

	const theme = useTheme()

	const useStyles = makeStyles((theme) => ({
		root: {
			padding: theme.spacing(2),
			width: "360px",
			height: "55px",
			"& .MuiTypography-h6": {
				...theme.typography.body2,
				paddingBottom: 1,
				color: theme.palette.grey["D100"],
				fontSize: theme.typography.fontSize,
			},
		},
		closeButton: {
			position: "absolute",
			right: theme.spacing(1),
			top: 2,
			color: theme.palette.grey[500],
		},
		dialogContent: {
			padding: theme.spacing(2),
		},
	}))

	const classes = useStyles()

	return (
		<Dialog
			style={{ ...theme.typography.body2 }}
			className={props?.dynamicClass ? props?.dynamicClass : "simpleDailog"}
			onClose={onClose}
			aria-labelledby="simple-dialog-title"
			open={open}
		>
			<MuiDialogTitle className={classes.root}>
				{title}
				{onClose ? (
					<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
						<CloseIcon />
					</IconButton>
				) : null}
			</MuiDialogTitle>
			<DialogContent dividers className={classes.dialogContent}>
				{props?.children}
			</DialogContent>
		</Dialog>
	)
}

export default Simple
